import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { RouterLink } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-search',
    imports: [MatButtonModule, MatIconModule, MatToolbarModule, RouterLink, TranslatePipe],
    templateUrl: './search.component.html',
    styleUrl: './search.component.css'
})
export class SearchComponent {

}
